import { Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

// Define routes specific to the RD Manager role
export const FinanceRoutes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import('@pages/finance/dashboard/dashboard').then((m) => m.Dashboard),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
  },
];
